<template>
    <div class="stf-heading">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
@use '@/assets/sass/_variables' as vars;
@use "bulma/sass/utilities/mixins";

.stf-heading {
  font-family: vars.$font-family-primary;
  font-weight: vars.$font-weight-semibold; /* Semi Bold */
  letter-spacing: -0.02em; /* -2% */
  line-height: 1;
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: vars.$font-size-25;

  @include mixins.mobile {
    margin-top: 7px;
    margin-bottom: 4px;
    font-size: vars.$font-size-20;
  }
}
</style>
